import { renderChips } from './renderChips';

export function rendererDefaultFactory(valueToString) {
  return function rendererDefault(args) {
    const { value = '', index, isSelected, isEditable } = args;
    if (!value) {
      return '';
    }

    const label = valueToString(value);
    return renderChips({ index, label, theme: 'ec-alt', isSelected, isEditable });
  };
}
